import React, { useState } from 'react'
import { DataTable, DataTableRow, Divider, Expander, ExpanderContent, ExpanderHeader, H5 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function OdmRecordEvents({ events }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)
  // This is the order that the admins requested for these events
  const eventOrder = ['Birth', 'Christening', 'Marriage', 'Death', 'Burial']

  events.sort((a, b) => {
    const orderPrecedence = (typeToCheck) => {
      return eventOrder.findIndex((type) => type === typeToCheck)
    }
    return orderPrecedence(a.type) - orderPrecedence(b.type)
  })

  return (
    <>
      <Divider marginY="nano" />
      <Expander open={open} setOpen={setOpen}>
        <ExpanderHeader>
          <H5>{t('odm.events', 'Events')}</H5>
        </ExpanderHeader>
        <ExpanderContent>
          <Divider marginY="nano" />
          {events && (
            <DataTable
              columns={[
                { label: t('odm.event.type', 'Type'), size: 'xs' },
                { label: t('odm.event.std', 'Std'), size: 'xs' },
                { label: t('odm.event.role', 'Role'), size: 'xs' },
                { label: t('odm.event.date', 'Original Date'), size: 'md' },
                { label: t('odm.event.place', 'Original Place'), size: 'lg' },
              ]}
            >
              {events.map((event) => {
                return (
                  <DataTableRow
                    key={event.id}
                    column1={(event.type ? event.type : '').substring(0, 3)}
                    column2={event.customTags?.[1]?.value?.substring(0, 3).toUpperCase()}
                    column3={event.customTags?.[0]?.value?.substring(0, 1)}
                    column4={event.date?.value}
                    column5={event.place?.placeName}
                  />
                )
              })}
            </DataTable>
          )}
          {!events || (events.length <= 0 && <p>{t('odm.noEvents', 'No Events')}</p>)}
          <Divider marginY="nano" />
        </ExpanderContent>
      </Expander>
    </>
  )
}
